module.exports = __webpack_public_path__ + "static/media/541d5274bcd0d5f124fb278f7ffc3de7.18a4ea36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/541d5274bcd0d5f124fb278f7ffc3de7.jpg
// module id = 263
// module chunks = 0